import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { CodeTypesController } from '../../models/master/mastermodel';
import { FacilityInfoController } from '../../models/actor/actor';


@Pipe({
  name: 'FacilitiesFilter'
})

@Injectable()
export class FacilitiesPipe implements PipeTransform {

  transform(value: FacilityInfoController[], filter: string): FacilityInfoController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: FacilityInfoController) =>
      app.FacilityDisplayName != null && app.FacilityDisplayName.toLocaleLowerCase().indexOf(filter) != -1

      || app.FacilityTypeName != null && app.FacilityTypeName.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}
